import { render, staticRenderFns } from "./Settles.vue?vue&type=template&id=15de79e1&"
import script from "./Settles.vue?vue&type=script&lang=js&"
export * from "./Settles.vue?vue&type=script&lang=js&"
import style0 from "./Settles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports